const cookie = {
  read: (name) => document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "",
};

export { cookie };
